module.exports = __webpack_public_path__ + "img/QA-alt.d3c30065.svg";